import router from './router'
import store from './store'
// import { Auth } from '@/utils/auth'
// import lazyLoading from './store/modules/menu/lazyLoading'
import { whiteList } from '@/router/index'

router.beforeEach((to, from, next) => {
  // for now we dotn activate secure feature
  if (store.getters.isUserLogged) {
    if (to.path.includes('/login')) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // if the user ask a login-liek url, we let it though.
      // it's because we need to whitlist login token in param
      if (to.path.includes('/login/')) {
        next()
      } else {
        next({ path: '/login' })
      }
    }
  } 
})



// WEBPACK FOOTER //
// ./src/permission.js